import React, { createContext, useContext, useState, useEffect } from "react";
import api from "../api/axiosConfig";
import { toast } from "react-toastify";
// 🟢 NEW: Import Auth Context
import { useAuth } from "./AuthContext";

const CostSheetContext = createContext();

export const useCostSheets = () => useContext(CostSheetContext);

export const CostSheetProvider = ({ children }) => {
  const [costSheets, setCostSheets] = useState([]);
  
  // 🟢 NEW: Get the current user
  const { user } = useAuth();

  // FETCH SHEETS
  const fetchSheets = async () => {
    try {
      const res = await api.get("/cost/sheets");
      setCostSheets(res.data);
    } catch (err) { console.error(err); }
  };
  
  // 🟢 FIX: Only fetch if user is logged in
  useEffect(() => {
    if (user && user.id) {
      fetchSheets();
    } else {
      setCostSheets([]);
    }
  }, [user]);

  // ACTIONS
  const createCostSheet = async (data) => {
    try {
      const res = await api.post("/cost/sheets", data);
      setCostSheets(prev => [res.data, ...prev]);
      toast.success("Cost Sheet Created");
    } catch (err) { toast.error("Failed to create"); }
  };

  const updateCostSheetStatus = async (id, newStatus) => {
    try {
      await api.put(`/cost/sheets/${id}/status`, { status: newStatus });
      setCostSheets(prev => prev.map(s => String(s.id) === String(id) ? { ...s, status: newStatus } : s));
      toast.success(`Status updated to ${newStatus}`);
    } catch (err) { toast.error("Update failed"); }
  };

  const getProjectCostSheets = (projectId) => {
    if (!projectId) return [];
    return costSheets.filter(s => String(s.projectId) === String(projectId));
  };

  // 🟢 NEW: FUNCTIONS TO FILL DB TABLES
  const addCostMaterial = async (data) => {
    try { await api.post("/cost/materials", data); return true; } 
    catch (e) { console.error(e); return false; }
  };

  const addCostLabor = async (data) => {
    try { await api.post("/cost/labor", data); return true; } 
    catch (e) { console.error(e); return false; }
  };

  const addCostEquipment = async (data) => {
    try { await api.post("/cost/equipment", data); return true; } 
    catch (e) { console.error(e); return false; }
  };

  const addCostScrap = async (data) => {
    try { await api.post("/cost/scrap", data); return true; } 
    catch (e) { console.error(e); return false; }
  };

  // 🟢 NEW: FUNCTION TO READ DB TABLES (For Detail View)
  const getSheetDetails = async (sheetId) => {
    try {
        const [mat, lab, eq, scr] = await Promise.all([
            api.get(`/cost/materials/${sheetId}`),
            api.get(`/cost/labor/${sheetId}`),
            api.get(`/cost/equipment/${sheetId}`),
            api.get(`/cost/scrap/${sheetId}`)
        ]);
        return {
            materials: mat.data,
            labor: lab.data,
            equipment: eq.data,
            scrap: scr.data
        };
    } catch (e) {
        console.error(e);
        return { materials: [], labor: [], equipment: [], scrap: [] };
    }
  };

  return (
    <CostSheetContext.Provider value={{ 
      costSheets, 
      createCostSheet, 
      updateCostSheetStatus, 
      getProjectCostSheets,
      addCostMaterial, 
      addCostLabor, 
      addCostEquipment, 
      addCostScrap,
      getSheetDetails // Export this for the Detail Page
    }}>
      {children}
    </CostSheetContext.Provider>
  );
};